import { hasItem } from '@sravni/ugc/lib/specialOffers/helpers';
import {
  BUSINESS_OFFERS,
  BUSINESS_OFFERS_LIST,
  COMMON_OFFERS,
  EDUCATION_OFFERS,
} from '@sravni/ugc/lib/specialOffers/lists';
import type { Tab, VITRINS_OFFERS_TYPE } from '@sravni/ugc/lib/specialOffers/types';

import type { IShortOrganization } from '../../interfaces/organizations';
import type { IAnalyticsParams } from '../../store/reducers/offers';
import { getTabsInfo } from '../getTabsInfo';

import { getEducationLinks } from './getEducationLinks';
import { getLeasingLinks } from './getLeasingLinks';

interface GetOffersLinksParams {
  tab: Tab<VITRINS_OFFERS_TYPE>;
  item: any;
  utmParams: IAnalyticsParams['utmParams'];
  organization: IShortOrganization;
  isPopup: boolean;
}

// eslint-disable-next-line max-statements
export const getOfferLinks = ({
  item,
  organization,
  tab,
  utmParams,
  isPopup,
}: GetOffersLinksParams): {
  clickUrl?: string;
  viewUrl?: string;
} => {
  let viewOfferUrl: URL = null;
  let clickOfferUrl: URL = null;

  if (tab.type === EDUCATION_OFFERS.learning) {
    const links = getEducationLinks({ item });

    viewOfferUrl = links?.viewOfferUrl;
    clickOfferUrl = links?.clickOfferUrl;
  }

  if (tab.type === BUSINESS_OFFERS.biznesLeasing) {
    ({ clickOfferUrl } = getLeasingLinks());

    return {
      clickUrl: clickOfferUrl.toString(),
    };
  }

  const { ad, advertising, url, alias } = item;
  const advertisingInfo = ad || advertising;
  const hasAdvertising = advertisingInfo?.monetization?.pixels;
  const isCard = tab.type === COMMON_OFFERS.creditCards || tab.type === COMMON_OFFERS.debitCards;

  if (!hasAdvertising) {
    let clickUrl = '';

    const tabsInfo = getTabsInfo(tab);

    if (isCard) {
      clickUrl = url;
    } else if (item.redirect) {
      clickUrl = item.redirect;
    } else if (tabsInfo.linkToOneProduct) {
      clickUrl = `/bank/${organization.alias}/${tabsInfo.linkToOneProduct}/${alias}/`;
    } else if (hasItem(BUSINESS_OFFERS_LIST, tab)) {
      clickUrl = tabsInfo.generalLink;
    } else {
      clickUrl = tabsInfo.generalLink;
    }
    return { clickUrl };
  }

  try {
    viewOfferUrl = new URL(advertisingInfo.monetization.pixels.display);
    clickOfferUrl = new URL(advertisingInfo.monetization.pixels.click);
  } catch (error) {
    console.error(error);
  }

  Object.entries(utmParams).forEach(([key, value]) => {
    // let paramValue = encodeURIComponent(value);
    let paramValue = value;

    if (key === 'source' && value === 'recommendation' && isPopup) {
      paramValue = `${value}_pop-up`;
    }

    viewOfferUrl && viewOfferUrl.searchParams.set(key, paramValue);
    clickOfferUrl && clickOfferUrl.searchParams.set(key, paramValue);
  });

  return {
    ...(viewOfferUrl && { viewUrl: viewOfferUrl.toString() }),
    ...(clickOfferUrl && { clickUrl: clickOfferUrl.toString() }),
  };
};
